<script lang="ts" setup>
defineProps<{
  data?: string;
  subTitle?: string;
}>();
</script>

<template>
  <h1 class="h2">
    {{ data }}
    <small v-if="subTitle" class="text-sm text-gray-500">{{ subTitle }}</small>
  </h1>
</template>

<style scoped>

</style>
